<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/164q5xL/tc-custom/9781488039225.jpg?1726617345522" alt="This image is the cover for the book Echo Lake, The Swift River Valley Novels"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Echo Lake, The Swift River Valley Novels
      </h1>
      <p class="bookDescription body article font2">
        <b>A frosty New England winter is enlivened with the spark of new love in the <i>New York Times</i>–bestselling author’s charming small-town romance.</b><br/><br/>Heather Sloan has landed her dream job—renovating Vic Scarlatti’s 1912 country home in Knights Bridge, Massachusetts. Overlooking the icy waters of Echo Lake, the stately old home is the perfect project for the family business. And for once, Heather is in charge.<br/><br/>Diplomatic Security Service agent Brody Hancock left Knights Bridge at eighteen, a few steps ahead of arrest and the wrath of Heather’s older brothers. Though Brody had never planned to return, his friend Vic, a retired diplomat, needs his help.<br/><br/>Staying at Vic’s guest house makes it impossible to avoid running into Heather at every turn. Seeing her again has affected Brody more than he wants to admit. But Heather is wary of Brody’s sudden interest in her, and she suspects there’s more to his homecoming than he’s letting on. . . .
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Carla Neggers
      </h2>
      
      <p class="authorDescription body article">Carla Neggers is the&#160;<I>New York Times</I> bestselling author of the Sharpe and Donovan series featuring Boston-based FBI agents Emma Sharpe and Colin Donovan and the Swift River Valley series set in small-town New England. With many bestsellers to her credit, Carla and her husband divide their time between their hilltop home in Vermont, their kids&#39; places in Boston and various inns, hotels and hideaways on their travels, frequently to Ireland. Learn more at CarlaNeggers.com.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin Enterprises Limited
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?667f9d9e